import { ajax } from "../../app/core/ajax";
import * as entities from "../../constants/entities";
import { buildValidationMessage } from "../controls/validation";
import { alert } from "../core/alert";
import { errorCode } from "../core/errorHandling";
import { getErrorCode } from "../core/getErrorCode";
import { ll, LocalizedLanguage } from "../core/ll";
import { emptyFn } from "../core/util";
import { codes } from "../data/codes";

export function updateEntity(args) {
    var dto = args.dto,
        validator = args.validator,
        success = args.success || emptyFn,
        error = args.error || emptyFn,
        entityType = args.entityType,
        keyField = args.keyField,
        ajaxButton = args.ajaxButton,
        unmask = args.unmask || emptyFn,
        friendlyEntityName = args.friendlyEntityName,
        showMessages = args.showMessages,
        hideDuplicateMessage = args.hideDuplicateMessage,
        urlPrefix = args.urlPrefix || "",
        beforeSend = args.beforeSend,
        e = args.e;

    var entityLL = friendlyEntityName || entityType;
    if (LocalizedLanguage["Entity." + entityLL]) {
        entityLL = "Entity." + entityLL;
    }

    var deferred = $.Deferred<any>();

    if (validator == undefined || validator.validate()) {
        if (typeof args.pulldownCallback === "function") {
            args.timelineUpdateCallback(args.dto);
        }
        ajax({
            type: dto.Id ? "PATCH" : "POST",
            url: urlPrefix + entityType,
            data: dto,
            beforeSend: beforeSend,
            errorHandled: (args.handleErrorMyself || args.errorHandled ? true : false),
            companyGuid: args.companyGuid
        }).done(function (response) {
            var callback = function () {
                alert({
                    header: ll("SaveSuccessful"),
                    message: ll("SaveSuccessfulMessage").format(ll(entityLL)),
                    type: "success"
                });

                if (ajaxButton) {
                    ajaxButton.buttonSuccess({ buttonObj: ajaxButton, message: ll("SaveSuccessful") });
                }
            };
            if (success) {
                success(response, callback);
                if (showMessages) {
                    callback();
                }
            } else {
                callback();
            }

            if (typeof args.timelineUpdateCallback === "function") {
                args.pulldownCallback(response);
            }

            deferred.resolve({
                response: response,
                successCallback: callback
            });
            unmask();
        }).fail(function (response) {
            unmask();
            if (args.handleErrorMyself) {
                args.handleErrorMyself(response);
            } else {
                if (response.status == 409) {
                    if (entityType == "TechTeam") {
                        var teamName = "";
                        $.each(codes.Team, function (index, item) {
                            if (item.Id == dto.TeamId) {
                                teamName = item.CodeNumber;
                                return false;
                            }
                        });

                        alert({
                            header: ll("Duplicate").format(ll(entityLL)),
                            message: ll("DuplicateTeamMessage").format(ll(teamName)),
                            type: "danger"
                        });
                    } else if (entityType == "TechSpecialty") {
                        var specialtyName = "";
                        $.each(codes.Specialty, function (index, item) {
                            if (item.Id == dto.SpecialtyId) {
                                specialtyName = item.CodeNumber;
                                return false;
                            }
                        });

                        alert({
                            header: ll("Duplicate").format(ll(entityLL)),
                            message: ll("DuplicateSpecialtyMessage").format(specialtyName),
                            type: "danger"
                        });
                    } else if (entityType == "CustomerContact") {
                        alert({
                            header: ll("Duplicate").format(ll("Default")),
                            message: ll("DuplicateDefaultMessage"),
                            type: "danger"
                        });
                    } else if (entityType == "CallItem") {
                        alert({
                            header: ll("Duplicate").format(ll(entityLL)),
                            message: ll("DuplicateCallItemMessage"),
                            type: "danger"
                        });
                    } else if (entityType == "OrderSegment") {
                        if (getErrorCode(response) == errorCode.CannotUpdateInvoicedSegment) {
                            alert({
                                header: ll("SaveFailed"),
                                message: ll("CannotUpdateInvoicedSegmentMessage"),
                                type: "danger"
                            });
                        } else {
                            displayGenericSaveFailedMessage();
                        }
                    } else if (entityType == entities.OrderLine
                               || entityType == entities.OrderTemplateLine
                               || entityType == entities.QuoteLine
                               || entityType == entities.ContractVisitLine
                    ) {
                        var code = getErrorCode(response);

                        if (code == errorCode.NegativeQuantityIsNotAllowed) {
                            alert({
                                header: ll("SaveFailed"),
                                message: ll("NegativeQuantityIsNotAllowed"),
                                type: "danger"
                            });
                        } else if (code == errorCode.NegativePriceIsNotAllowed) {
                            alert({
                                header: ll("SaveFailed"),
                                message: ll("NegativePriceIsNotAllowed"),
                                type: "danger"
                            });
                        } else {
                            displayGenericSaveFailedMessage();
                        }
                    } else if (!hideDuplicateMessage) {
                        alert({
                            header: ll("Duplicate").format(ll(entityLL)),
                            message: ll("DuplicateMessage").format(ll(entityLL), ll(keyField)),
                            type: "danger"
                        });
                    }
                } else {
                    displayGenericSaveFailedMessage();
                }
                if (ajaxButton) {
                    ajaxButton.buttonFail({ buttonObj: ajaxButton, message: ll("SaveUnsuccessful") });
                }

            }
            error && error(response);
            deferred.reject({
                response: response
            });
        });
    } else {
        if (!args.handleValidationrMyself) {
            var validationMessage = buildValidationMessage(validator.validationErrors);

            alert({
                header: ll("ValidationIssues"),
                message: validationMessage,
                messageIsHTML: true,
                type: "danger",
                wait: 15000
            });
            if (ajaxButton) {
                ajaxButton.buttonFail({ buttonObj: ajaxButton, message: ll("SaveUnsuccessful") });
            }
            if (e) {
                e.preventDefault();
            }
        }
        deferred.reject({
            validator: validator
        });
        unmask();
    }

    return deferred;

    function displayGenericSaveFailedMessage() {
        alert({
            header: ll("SaveFailed"),
            message: ll("SaveFailedMessage").format(ll(entityLL)),
            type: "danger"
        });
    }

}
